<!--begin::Modal - Bulk Update Courier Manager-->
<div class="modal fade" id="kt_modal_courier_manager_bulk_update" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-900px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">
          Bulk Update Courier Manager
          <span class="badge badge-primary ms-2">{{ selectedItems.length }} selected</span>
        </h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="bulkForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="text-muted fs-7 mb-4">
            Only the fields you fill in below will be applied to all {{ selectedItems.length }} selected record(s). Leave a field empty to keep its existing value unchanged.
          </div>
          <div class="row">
            <!-- Courier Company (Searchable) -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Courier Company</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [value]="courierCompanySearchTerm"
                  (input)="onCourierCompanySearchInput($event)" (focus)="onCourierCompanyInputFocus()"
                  (blur)="onCourierCompanyInputBlur()" placeholder="Search courier companies..." autocomplete="off" />

                <!-- Courier Company Search Dropdown -->
                <div class="dropdown-menu show w-100 mh-300px overflow-auto" *ngIf="showCourierCompanyDropdown"
                  style="position: absolute; top: 100%; left: 0; z-index: 1000;">
                  <div class="dropdown-item text-center py-2" *ngIf="isCourierCompanySearching">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Searching...
                  </div>
                  <div class="dropdown-item text-center py-2 text-muted"
                    *ngIf="!isCourierCompanySearching && courierCompanySearchResults.length === 0">
                    No courier companies found
                  </div>
                  <a href="#" class="dropdown-item py-2" *ngFor="let company of courierCompanySearchResults"
                    (click)="selectCourierCompany(company); $event.preventDefault()">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1">
                        <div class="fw-bold">{{ company.company_name || company.name || 'Unknown Company' }}</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- Status -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Status</label>
              <select class="form-select form-select-solid" formControlName="status">
                <option value="">No Change</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
              </select>
            </div>

            <!-- Order Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Order Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="order_date" />
            </div>

            <!-- Surrender Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Surrender Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="surrender_date" />
            </div>

            <!-- Complete Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Complete Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="complete_date" />
            </div>

            <!-- Docs Released Date -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Docs Released Date</label>
              <input type="date" class="form-control form-control-solid" formControlName="docs_released_date" />
            </div>

            <!-- Tracking Number -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Tracking Number</label>
              <input type="text" class="form-control form-control-solid" formControlName="tracking_number"
                placeholder="Enter tracking number" />
            </div>

            <!-- Remarks -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Remarks</label>
              <textarea class="form-control form-control-solid" formControlName="remarks" rows="3"
                placeholder="Enter remarks"></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal" [disabled]="isLoading">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="isLoading || selectedItems.length === 0">
            <span class="indicator-label">Update {{ selectedItems.length }}</span>
            <span class="indicator-progress" *ngIf="isLoading">
              Please wait...
              <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--end::Modal - Bulk Update Courier Manager-->
